@for (item of items; track item) {
  <div>
    <h5>{{ item.label }}</h5>
    <p>{{ item.value || "\u2014" }}</p>
  </div>
}
